<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<span class="chip" [class.selected]="chip.id === selectedValue?.id" *ngFor="let chip of chips" (click)="setSelected(chip)">
  {{ chip.name }}
</span>
